import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { AuthProvider } from "./auth";
import "./i18n";
import "./styles.css";
import { TaskProvider } from "./tasks";

createRoot(document.getElementById("root")!).render(
  <StrictMode><BrowserRouter><AuthProvider><TaskProvider><App /></TaskProvider></AuthProvider></BrowserRouter></StrictMode>,
);
